module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark@2x-164c13813497e45e84dda951c8c1c152.png";